import api from './api'

export const clinicaService = {
  async getAll(params = {}) {
    const response = await api.get('/clinicas', { params })
    return response.data
  },

  async getById(id) {
    const response = await api.get(`/clinicas/${id}`)
    return response.data
  },

  async create(data) {
    const response = await api.post('/clinicas', data)
    return response.data
  },

  async update(id, data) {
    const response = await api.put(`/clinicas/${id}`, data)
    return response.data
  },

  // Soft delete - marca como eliminado
  async delete(id) {
    const response = await api.delete(`/clinicas/${id}`)
    return response.data
  },

  // Configurar política de emergencias
  async configurarEmergencias(id, data) {
    const response = await api.post(`/clinicas/${id}/configurar-emergencias`, data)
    return response.data
  },
}

